import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatsCardProps {
  icon: BoxIcon;
  label: string;
  value: string;
  subValue?: string;
  trend?: 'up' | 'down' | 'neutral';
}
export function StatsCard({
  icon: Icon,
  label,
  value,
  subValue,
  trend
}: StatsCardProps) {
  const trendColors = {
    up: 'text-green-500',
    down: 'text-red-500',
    neutral: 'text-gray-400'
  };
  return <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6 hover:border-orange-500/50 transition-colors" data-id="element-68">
      <div className="flex items-start justify-between mb-4" data-id="element-69">
        <div className="w-12 h-12 bg-orange-500/10 rounded-lg flex items-center justify-center" data-id="element-70">
          <Icon className="w-6 h-6 text-orange-500" data-id="element-71" />
        </div>
      </div>
      <div className="space-y-1" data-id="element-72">
        <p className="text-gray-400 text-sm font-medium" data-id="element-73">{label}</p>
        <p className="text-white text-2xl font-bold font-mono" data-id="element-74">{value}</p>
        {subValue && <p className={`text-sm font-medium ${trend ? trendColors[trend] : 'text-gray-400'}`} data-id="element-75">
            {subValue}
          </p>}
      </div>
    </div>;
}